var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackwardStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 88V424C32 437.254 42.746 448 56 448S80 437.254 80 424V318.17L253.406 442.031C258.938 446 265.438 448 272 448C277 448 282.031 446.844 286.656 444.469C297.312 438.969 304 428 304 416V96C304 84 297.312 73.031 286.656 67.531C282.037 65.174 277.008 64.002 271.996 64.002C265.447 64.004 258.93 66.004 253.406 69.969L80 193.83V88C80 74.746 69.254 64 56 64S32 74.746 32 88ZM80 252.816L107.9 232.889L256 127.104V384.896L107.898 279.111L80 259.182V252.816Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardStep);
export default __webpack_public_path__ + "static/media/backward-step.8b0f5af0b8a5da99b894f308253f48f5.svg";
export { ForwardRef as ReactComponent };